import React, { useState } from 'react';
import { MessageModal } from 'ui/Modals';
import { contactTypes, contactTargets } from 'shared/constants/contactBox';
import { useContact } from 'shared/hooks';

export const useContactAdvisor = () => {
  const [messageModalOpen, setMessageModalOpen] = useState(false);
  const [messageSent, setMessageSent] = useState(false);
  const contact = useContact({ onSuccess: () => setMessageSent(true) });
  const toggleMessageModal = () => setMessageModalOpen(!messageModalOpen);
  const handleContact = (type, target) => async ({ subject, message, origin }) => {
    contact({ type, subject, message, origin, target });
  };

  const RenderModal = () => (
    <MessageModal
      open={messageModalOpen}
      onClose={toggleMessageModal}
      onSendMessage={handleContact(contactTypes.MESSAGE, contactTargets.PERSONAL_ADVISER)}
    />
  );

  return [messageSent, toggleMessageModal, RenderModal];
};
